import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import {
	PagingSearchFieldArgument,
	PagingSearchFieldArrayArgument,
} from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';
import { ProgramFileModel } from './management/files-service/program-file.model';

export class OrganizationTierModel {
	name: string;
	category: number;
}

export function OrganizationTierModel_ClassTransform_Type() {
	return OrganizationTierModel;
}

export class OrganizationModel {
	public id: number;
	public is_active: boolean;
	public unique_id: string;
	public itype_shortcode: string;
	public title: string;
	public subtitle?: string;
	public state: string;
	public parent?: string;
	public parent_title?: string;
	public timezone?: string;
	@Transform(dateTransformer)
	public created: Date;
	public itype_id: number;
	public ready_for_students: boolean | number;

	is_structural?: boolean;
	active_admin_count?: number;
	enrolled_student_count?: number;
	created_timestamp?: number;
	files?: ProgramFileModel[];
	groups?: unknown[];
	institute_id?: number;
	institute_title?: string;
	parent_institute_title?: string;
	properties?: Record<string, unknown>;
	tags?: string[];
	@Type(OrganizationTierModel_ClassTransform_Type)
	tiers?: OrganizationTierModel[];
	salesforce_id?: string;
}

export function OrganizationSearchModel_ClassTransform_Type() {
	return OrganizationSearchModel;
}

export class OrganizationSearchModel {
	@Type(OrganizationSearchModel_ClassTransform_Type)
	institutes: OrganizationModel[];
	count: number;
}

export interface OrganizationSearchArgument {
	institute_title: PagingSearchFieldArgument;
	state: PagingSearchFieldArgument;
	itype_shortcode: PagingSearchFieldArgument;
	parent_institute_title: PagingSearchFieldArgument;
	is_active: PagingSearchFieldArgument<boolean>;
	is_structural: PagingSearchFieldArgument<boolean>;
	ready_for_students: PagingSearchFieldArrayArgument;
	created: PagingSearchFieldArgument;
	enrolled_student_count: PagingSearchFieldArgument;
	active_admin_count: PagingSearchFieldArgument;
	properties: PagingSearchFieldArgument;
	tags: PagingSearchFieldArgument;
	tiers: PagingSearchFieldArrayArgument;
	salesforce_id: PagingSearchFieldArgument;
}
